import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";

export class FreespinScatterResult extends SymbolWinResult {
}
